"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIMELINE_LEFT_OFFSET = exports.TIMELINE_LABEL_WIDTH = void 0;
var TIMELINE_LABEL_WIDTH = 100;
exports.TIMELINE_LABEL_WIDTH = TIMELINE_LABEL_WIDTH;
var TIMELINE_LEFT_OFFSET = 64;
exports.TIMELINE_LEFT_OFFSET = TIMELINE_LEFT_OFFSET;